export function noop(ev) {
  const el = ev.target;

  if (el.hasAttribute('disabled')) {
    ev.preventDefault();
    ev.stopPropagation();
  }
}
